import validations from 'constants/validations'

const getMimeTypeFromExtension = (filename) => {
  const extension = filename
    .substring(filename.lastIndexOf('.') + 1)
    .toLowerCase()

  return (
    validations.MIME_TYP_VALIDATION[extension] ||
    validations.UNKNOWN_FILE_MIME_TYPE
  )
}

export default getMimeTypeFromExtension
